import { isInsidePeriod } from '~/utils';
import { ECSchema } from '~/types/api';
import { ProductListItem, TopItemCard } from '~/types/modules/product';
import { LotteryApplicationType } from '~/enums';

export const checkLotteryStatus = (
  // 応募開始日
  applicationStartTime: string,
  // 応募終了日
  applicationEndTime: string,
  // 商品購入開始日時
  purchaseStartTime: string,
  // 抽選制御終了日
  raffleControlEndTime: string
) => {
  // 抽選期間内の場合
  if (isInsidePeriod(applicationStartTime, applicationEndTime)) return LotteryApplicationType.WITHIN_APPLICATION_PERIOD;

  // 「応募期間終了〜商品購入可能期間開始」または「商品購入可能期間開始〜抽選制御期間終了」は抽選期間外
  if (isInsidePeriod(applicationEndTime, purchaseStartTime) || isInsidePeriod(purchaseStartTime, raffleControlEndTime))
    return LotteryApplicationType.WITHOUT_APPLICATION_PERIOD;

  return LotteryApplicationType.OTHER;
};

export const getLotteryInfoFromSearch = (item: ProductListItem | TopItemCard) => {
  const lotteryInfo = item.raffle;
  // 抽選情報がない場合はまたは抽選情報が複数ある場合は「カートボタン表示」
  if (!lotteryInfo || !lotteryInfo[0] || lotteryInfo.length > 1)
    return { applicationStatus: LotteryApplicationType.OTHER };

  // 表示フラグonの子商品を抽出
  const activeChildren = item.children.filter((el: string) => {
    // 生産年_表示価格_新着フラグ_定価_在庫数_販売開始日時_販売終了日時_最高得点の評価誌種別_最高得点の評価誌ポイント_表示フラグ_子商品コード
    const child = el.split('_');
    return !!Number(child[9]);
  });
  // 複数ヴィンテージの場合は「カートボタン表示」
  if (activeChildren.length > 1) return { applicationStatus: LotteryApplicationType.OTHER };

  return {
    applicationStatus: checkLotteryStatus(
      lotteryInfo[0].applicationStartTime,
      lotteryInfo[0].applicationEndTime,
      lotteryInfo[0].purchaseStartTime,
      lotteryInfo[0].raffleControlEndTime
    ),
    id: Number(lotteryInfo[0].id),
  };
};

export const getLotteryInfoFromEC = (lotteryInfo?: ECSchema<'enotecaproduct.RaffleShow'>) => {
  if (!lotteryInfo)
    return {
      applicationStatus: LotteryApplicationType.OTHER,
    };

  return {
    applicationStatus: checkLotteryStatus(
      lotteryInfo.application_start_time,
      lotteryInfo.application_end_time,
      lotteryInfo.purchase_start_time,
      lotteryInfo.raffle_control_end_time
    ),
    id: lotteryInfo.id,
    raffle_control_start_time: lotteryInfo.raffle_control_start_time,
    raffle_control_end_time: lotteryInfo.raffle_control_end_time,
  };
};
